import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import authService from "../services/authService";
import { logger } from "../utils/logger";
const ProtectedRoute = ({ children, allowedRoles }) => {
  ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    allowedRoles: PropTypes.string,
  };
  const isTherapist = authService.isTherapist();
  const isStaff = authService.isStaff();
  const isAuthenticated = authService.isAuthenticated();
  if (!isAuthenticated) return <Navigate to="/" replace />;
  // Check role-based access
  if (allowedRoles) {
    const hasPermission =
      (allowedRoles === "therapist" && (isTherapist || isStaff) && !authService.isManagementOnly()) ||
      (allowedRoles === "client" && (authService.isClient() || isStaff)) ||
      (allowedRoles === "staff" && isStaff) ||
      (allowedRoles === "clinic-admin" && authService.isClinicAdmin()) ||
      (allowedRoles === "authenticated" && isAuthenticated);

    if (!hasPermission) {
      logger.info("Access denied!", {url: window.location.href});

      return <Navigate to={authService.isClinicAdmin() && (!isTherapist || authService.isManagementOnly()) ? "/team" : isTherapist ? "/clients" : "/programs"} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
